import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface AuthUser {
  id: string;
  login: string;
  name: string;
}

interface AuthState {
  user: AuthUser | null;
  isAuthenticated: boolean;
  setAuth: (user: AuthUser) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  devtools(
    (set) => ({
      user: null,
      isAuthenticated: false,
      setAuth: (user) => {
        set({ user, isAuthenticated: true }, undefined, 'auth/setAuth');
      },
      logout: () => {
        set({ user: null, isAuthenticated: false }, undefined, 'auth/logout');
      },
    }),
    { name: 'auth-store' },
  ),
);
